import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { FaApple, FaGooglePlay, FaTimes } from "react-icons/fa";
import logo from "../../assets/logo.svg";
import "./AppDownloadModal.css";

const APPLE_STORE_URL = "https://apps.apple.com/pl/app/sharecipe/id6470614602";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.sharecipe";

export const AppDownloadModal = ({ isOpen, onClose, title = "Get the ShareRecipe App" }) => {
  if (!isOpen) return null;

  return (
    <div className="app-modal-overlay" onClick={onClose}>
      <div className="app-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="app-modal-close" onClick={onClose} aria-label="Close modal">
          <FaTimes />
        </button>

        <div className="app-modal-header">
          <img src={logo} alt="ShareRecipe" className="app-modal-logo" />
          <h2>{title}</h2>
          <p>Scan the dynamic QR code with your phone camera or click below to download the official mobile app!</p>
        </div>

        <div className="app-modal-grid">
          {/* iOS Card */}
          <div className="store-card ios">
            <div className="store-badge">iOS App Store</div>
            <div className="qr-wrapper">
              <QRCodeCanvas
                value={APPLE_STORE_URL}
                size={140}
                bgColor="#FFFFFF"
                fgColor="#402864"
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="qr-caption">Scan to download for iPhone & iPad</p>
            <a
              href={APPLE_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-btn apple-btn"
            >
              <FaApple className="btn-icon" />
              <div>
                <span className="btn-sub">Download on the</span>
                <span className="btn-title">App Store</span>
              </div>
            </a>
          </div>

          {/* Android Card */}
          <div className="store-card android">
            <div className="store-badge">Google Play</div>
            <div className="qr-wrapper">
              <QRCodeCanvas
                value={GOOGLE_PLAY_URL}
                size={140}
                bgColor="#FFFFFF"
                fgColor="#1E293B"
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="qr-caption">Scan to download for Android devices</p>
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-btn play-btn"
            >
              <FaGooglePlay className="btn-icon" />
              <div>
                <span className="btn-sub">GET IT ON</span>
                <span className="btn-title">Google Play</span>
              </div>
            </a>
          </div>
        </div>

        <div className="app-modal-footer">
          <p className="community-notice">
            Join thousands of food lovers sharing recipes daily on ShareRecipe Mobile.
          </p>
        </div>
      </div>
    </div>
  );
};
